import React from 'react'

export const Separator = () =>
  <div className='korisnicki-profil-small-heading'>
    <p />
  </div>
